import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ILogin } from './authentication.interface';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthenticationService {
    constructor(private http: HttpClient) { }

    /**
     * @name userLogin
     * @param {ILogin} data
     * @desc admin login
     * @method POST
     * @return Observable<ILogin>
    */
    userLogin(login: ILogin): Observable<ILogin>{
       return this.http.post<ILogin>(environment.baseUrl + 'Account/Login', login);
    }
}